import {
  IPayerResponse,
  IPayerUpdateRequest
} from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const updatePayer = async (
  id: string,
  payload: IPayerUpdateRequest
): Promise<IPayerResponse> => {
  const response = await servicePayments.patch(`/payer/${id}`, payload);
  return response.data;
};
